import { Controller, useFormContext } from "react-hook-form";
import { Box } from "@mui/material";
import { StyledTextField } from "./StyleInputs";

const PhoneField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;

  return (
    <Box sx={{ mb: 3 }}>
      <Controller
        name={field.id}
        control={control}
        defaultValue=""
        rules={{
          required: field.required ? `${field.label} is required` : false,
          pattern: {
            value: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
            message: "Invalid phone number",
          },
        }}
        render={({ field: { onChange, value, ref } }) => (
          <StyledTextField
            fullWidth
            placeholder={field.placeholder}
            type="tel"
            value={value}
            onChange={onChange}
            inputRef={ref}
            error={!!errorMessage}
            helperText={errorMessage}
            variant="outlined"
            label={field.label}
            required={field.required}
          />
        )}
      />
    </Box>
  );
};

export default PhoneField;
